import { useContext, useMemo } from "react";
import Head from "next/head";
import Page from "../layouts/main";
import Footer from "../components/Footer/footer.module";
import Context from "../components/context/context";
import styles from "../styles/modules/release-and-waiver.module.scss";
import { ReleaseAndWaiver as data } from "../util/data";
import { DEFAULT_LOCATION, formatAddress } from "../util/locations";

export const ReleaseAndWaiver = () => {
  const { location } = useContext(Context);
  const locationToUse = useMemo(
    () => (location ? location : DEFAULT_LOCATION),
    [location]
  );
  const formattedAddress = useMemo(
    () => formatAddress(locationToUse.address),
    [locationToUse]
  );

  return (
    <Page id={styles["page-release-and-waiver"]}>
      <Head>
        <title>Release &amp; Waiver - Kudos Golf</title>
      </Head>

      <section
        className={`section-content ${styles["section-release-waiver"]}`}
      >
        <h2 className={styles.header}>Release and Waiver</h2>
        <div className={styles["release-waiver-container"]}>
          {data.map((item, index) => {
            const content =
              typeof item === "function" ? item(formattedAddress.province) : item;
            return (
              <p
                className={`text-body-medium ${styles["release-waiver-section-paragraph"]}`}
                key={index}
                dangerouslySetInnerHTML={{ __html: content }}
              ></p>
            );
          })}
        </div>
      </section>

      <Footer />
    </Page>
  );
};

export default ReleaseAndWaiver;
